export default __webpack_public_path__ + "static/media/banner4.4d4c1216.png";